var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16618 14.6667C7.16618 15.1269 7.53927 15.5 7.99951 15.5C8.45975 15.5 8.83284 15.1269 8.83284 14.6667V8.83333H14.6662C15.1264 8.83333 15.4995 8.46024 15.4995 8C15.4995 7.53976 15.1264 7.16667 14.6662 7.16667H8.83285V1.33333C8.83285 0.873096 8.45975 0.5 7.99951 0.5C7.53927 0.5 7.16618 0.873096 7.16618 1.33333V7.16667H1.33285C0.872608 7.16667 0.499512 7.53976 0.499512 8C0.499512 8.46024 0.872608 8.83333 1.33285 8.83333H7.16618V14.6667Z",
    fill: "#FF6C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d681256d105fa3d659b028cb6b1def02.svg";
export { ForwardRef as ReactComponent };